import { render, staticRenderFns } from "./announce_conc_ru.vue?vue&type=template&id=7bad77ca&scoped=true&"
import script from "./announce_conc_ru.vue?vue&type=script&lang=js&"
export * from "./announce_conc_ru.vue?vue&type=script&lang=js&"
import style0 from "./announce_conc_ru.vue?vue&type=style&index=0&id=7bad77ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bad77ca",
  null
  
)

export default component.exports